<!-- Main Menu -->
<nav>
  <div class="ws-menu">
    <div class="ws-menu__app-title" (click)="gotoRoute('welcome')">
      <div class="ws-menu__app-title-1"></div>
    </div>
    <div class="ws-menu__grow-spacer">&nbsp;</div>
    <div class="ws-menu__dd-link reg" [style.display]="hasInvInquirePermission ? 'inline-block' : 'none'" id="inventory">
      <div class="ws-menu__dd-link-title" (click)="toggleMenu('inventory')">Inventory</div>
    </div>
    <div
      class="ws-menu__dd-link reg"
      id="orders"
      [style.display]="
        hasOrdInquirePermission || hasOrdCreatePermission
          ? 'inline-block'
          : 'none'
      "
    >
      <div class="ws-menu__dd-link-title" (click)="toggleMenu('orders')">Orders</div>
    </div>
    <div class="ws-menu__dd-link reg" [style.display]="hasReportsPermission ? 'inline-block' : 'none'" id="reports">
      <div class="ws-menu__dd-link-title" (click)="toggleMenu('reports')">Reports</div>
    </div>
    <div class="ws-menu__dd-link reg" [style.display]="hasAdminPermission ? 'inline-block' : 'none'" id="admin">
      <div class="ws-menu__dd-link-title" (click)="toggleMenu('admin')">Admin</div>
    </div>
    <div class="ws-menu__dd-link reg" id="user">
      <div class="ws-menu__dd-link-title" (click)="toggleMenu('user')">User</div>
    </div>
    <div class="ws-menu__dd-link reg" (click)="logout()" id="logout">
      <div class="ws-menu__dd-link-title">Logout</div>
    </div>
    <div class="ws-menu__item rotate90 small" id="complete" (click)="toggleMenu('complete')">
      <div class="ws-menu__item-title ws-menu__small">|||</div>
    </div>
  </div>
</nav>

<!-- Inventory Popup Menu -->
<div class="zmodal zmodal--inventory" [class.zmodal--show]="(showMenu$ | async) === 'inventory'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content" [ngStyle]="menuMarginLeft">
      <div class="zmodal__body">
        <div class="zmodal__mitem" (click)="gotoRoute('inventory/summary')">
          <div class="zmodal__mitem--title"><i class="material-icons">search</i> Inquiry</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Order Popup Menu -->
<div class="zmodal zmodal--orders" [class.zmodal--show]="(showMenu$ | async) === 'orders'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content" [ngStyle]="menuMarginLeft">
      <div class="zmodal__body">
        <div
          class="zmodal__mitem"
          (click)="gotoRoute('orders/inquiry')"
          [style.display]="hasOrdInquirePermission ? 'flex' : 'none'"
        >
          <div class="zmodal__mitem--title"><i class="material-icons">search</i> Inquiry</div>
        </div>
        <div
          class="zmodal__mitem"
          (click)="gotoRoute('orders/create/inbound')"
          [style.display]="hasOrdCreatePermission ? 'flex' : 'none'"
        >
          <div class="zmodal__mitem--title"><i class="material-icons">get_app</i> Create Inbound</div>
        </div>
        <div
          class="zmodal__mitem"
          (click)="gotoRoute('orders/create/outbound')"
          [style.display]="hasOrdCreatePermission ? 'flex' : 'none'"
        >
          <div class="zmodal__mitem--title"><i class="material-icons">publish</i> Create Outbound</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reports Popup Menu -->
<div class="zmodal zmodal--reports" [class.zmodal--show]="(showMenu$ | async) === 'reports'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content" [ngStyle]="menuMarginLeft">
      <div class="zmodal__body">
        <div class="zmodal__mitem" (click)="gotoRoute('reports/generate')">
          <div class="zmodal__mitem--title"><i class="material-icons">library_books</i> Run Report</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Admin Popup Menu -->
<div class="zmodal zmodal--admin" [class.zmodal--show]="(showMenu$ | async) === 'admin'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content" [ngStyle]="menuMarginLeft">
      <div class="zmodal__body">
        <div class="zmodal__mitem" (click)="gotoRoute('admin/user-lookup')">
          <div class="zmodal__mitem--title"><i class="material-icons">verified_user</i> User Maintenance</div>
        </div>
        <div class="zmodal__mitem" (click)="gotoRoute('admin/user-create')" [style.display]="hasAdminPermission ? '' : 'none'">
          <div class="zmodal__mitem--title"><i class="material-icons">add</i> User Create</div>
        </div>
        <div
          class="zmodal__mitem"
          (click)="gotoRoute('admin/user-image-upload')"
          [style.display]="hasAdminPermission ? '' : 'none'"
        >
          <div class="zmodal__mitem--title"><i class="material-icons">image</i> Image Upload</div>
        </div>

        <div
          class="zmodal__mitem"
          (click)="gotoRoute('admin/refresh-reports')"
          [style.display]="hasAdminPermission ? '' : 'none'"
        >
          <div class="zmodal__mitem--title"><i class="material-icons">refresh</i> Refresh Reports List</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- User Popup Menu -->
<div class="zmodal zmodal--user" [class.zmodal--show]="(showMenu$ | async) === 'user'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content" [ngStyle]="menuMarginLeft">
      <div class="zmodal__body">
        <div class="zmodal__mitem" (click)="showChangeCustomer()">
          <div class="zmodal__mitem--title"><i class="material-icons">people</i> Change Customer</div>
        </div>
        <div class="zmodal__mitem" (click)="showChangeFacility()">
          <div class="zmodal__mitem--title"><i class="material-icons">home</i> Change Facility</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Menu Icon Push -->
<div class="zmodal zmodal--complete" [class.zmodal--show]="(showMenu$ | async) === 'complete'" (click)="dismissMenu()">
  <div class="zmodal__wrapper">
    <div class="zmodal__content">
      <div class="zmodal__body">
        <!-- Inventory Section -->
        <div class="zmodal__mgroup" [style.display]="hasInvInquirePermission ? '' : 'none'">
          <div class="zmodal__mheader">Inventory</div>
          <div class="zmodal__mitem" (click)="gotoRoute('inventory/summary')">
            <div class="zmodal__mitem--title"><i class="material-icons">remove_red_eye</i> Inquiry</div>
          </div>
        </div>

        <!-- Orders Section -->
        <div
          class="zmodal__mgroup"
          [style.display]="
            hasOrdInquirePermission || hasOrdCreatePermission
              ? ''
              : 'none'
          "
        >
          <div class="zmodal__mheader">Orders</div>
          <div
            class="zmodal__mitem"
            (click)="gotoRoute('orders/inquiry')"
            [style.display]="hasOrdInquirePermission ? '' : 'none'"
          >
            <div class="zmodal__mitem--title"><i class="material-icons">remove_red_eye</i> Inquiry</div>
          </div>
          <div
            class="zmodal__mitem"
            (click)="gotoRoute('orders/create/inbound')"
            [style.display]="hasOrdCreatePermission ? '' : 'none'"
          >
            <div class="zmodal__mitem--title"><i class="material-icons">get_app</i> Create Inbound</div>
          </div>
          <div
            class="zmodal__mitem"
            (click)="gotoRoute('orders/create/outbound')"
            [style.display]="hasOrdCreatePermission ? '' : 'none'"
          >
            <div class="zmodal__mitem--title"><i class="material-icons">publish</i> Create Outbound</div>
          </div>
        </div>

        <!-- Reports Section -->
        <div class="zmodal__mgroup" [style.display]="hasReportsPermission ? '' : 'none'">
          <div class="zmodal__mheader">Reports</div>
          <div class="zmodal__mitem" (click)="gotoRoute('reports/generate')">
            <div class="zmodal__mitem--title"><i class="material-icons">library_books</i> Run Report</div>
          </div>
        </div>

        <!-- Admin Section -->
        <div class="zmodal__mgroup" [style.display]="hasAdminPermission ? '' : 'none'">
          <div class="zmodal__mheader">Admin</div>
          <div class="zmodal__mitem" (click)="gotoRoute('admin/user-lookup')">
            <div class="zmodal__mitem--title"><i class="material-icons">verified_user</i> User Maintenance</div>
          </div>

          <div class="zmodal__mitem" (click)="gotoRoute('admin/user-create')" [style.display]="hasAdminPermission ? '' : 'none'">
            <div class="zmodal__mitem--title"><i class="material-icons">add</i> User Create</div>
          </div>
          <div
            class="zmodal__mitem"
            (click)="gotoRoute('admin/user-image-upload')"
            [style.display]="hasAdminPermission ? '' : 'none'"
          >
            <div class="zmodal__mitem--title"><i class="material-icons">image</i> Image Upload</div>
          </div>

          <div
            class="zmodal__mitem"
            (click)="gotoRoute('admin/refresh-reports')"
            [style.display]="hasAdminPermission ? '' : 'none'"
          >
            <div class="zmodal__mitem--title"><i class="material-icons">refresh</i> Refresh Reports List</div>
          </div>
        </div>

        <!-- User Section -->
        <div class="zmodal__mgroup">
          <div class="zmodal__mheader">User</div>
          <div class="zmodal__mitem" (click)="showChangeCustomer()">
            <div class="zmodal__mitem--title"><i class="material-icons">people</i> Change Customer</div>
          </div>
          <div class="zmodal__mitem" (click)="showChangeFacility()">
            <div class="zmodal__mitem--title"><i class="material-icons">home</i> Change Facility</div>
          </div>
        </div>

        <div class="zmodal__mitem zmodal__mitem--logout" (click)="logout()">
          <div class="zmodal__mitem--title"><i class="material-icons">pan_tool</i> Logout</div>
        </div>
      </div>
    </div>
  </div>
</div>
